export const Lightning_Section = [
    {
        title: "لامپ",
        link: "/lamp",
        childs: [
            {
                name: "لامپ شمعی",
                link: "/lamp-candle"
            },
            {
                name: "لامپ اشکی",
                link: "/lamp-candle"
            },
            {
                name: "لامپ فیلامنتی",
                link: "/lamp-candle"
            },
            {
                name: "لامپ COB",
                link: "/lamp-candle"
            },
            {
                name: "لامپ حبابی",
                link: "/lamp-candle"
            },
        ]
    },
    {
        title: "ال ای دی",
        link: "/lamp",
        childs: [
            {
                name: "لامپ LED توان بالا (Hight Power)",
                link: "/lamp-candle"
            },
            {
                name: "لامپ LED طرح دار",
                link: "/lamp-candle"
            },
            {
                name: "لامپ LED خطی",
                link: "/lamp-candle"
            },
            {
                name: "لامپ LED خطی FPL و PPL",
                link: "/lamp-candle"
            },
            {
                name: "لامپ LED خطی براکتی",
                link: "/lamp-candle"
            },
            {
                name: "لامپ LED هالوژن",
                link: "/lamp-candle"
            },
            {
                name: "قاب و فریم هالوژن",
                link: "/lamp-candle"
            },
            {
                name: "سوکت و تبدیل هالوژن",
                link: "/lamp-candle"
            },
        ]
    },
    {
        title: "دکوراتیو داخلی",
        link: "/lightning-decorative",
        childs: [
            {
                name: "چراغ بالا اینه",
                link: "/lamp-candle"
            },
            {
                name: "ریسه نواری",
                link: "/lamp-candle"
            },
            {
                name: "لوازم جانبی ریسه نواری",
                link: "/lamp-candle"
            },
            {
                name: "چراغ خطی",
                link: "/lamp-candle"
            },
            {
                name: "چراغ ساده",
                link: "/lamp-candle"
            },
            {
                name: "چراغ LED",
                link: "/lamp-candle"
            },
            {
                name: "پنل LED",
                link: "/lamp-candle"
            },
            {
                name: "چراغ سقفی",
                link: "/lamp-candle"
            },
            {
                name: "چراغ خواب",
                link: "/lamp-candle"
            },
            {
                name: "چراغ خطی زیر کابینتی",
                link: "/lamp-candle"
            },
            {
                name: "فریم پنل",
                link: "/lamp-candle"
            },
        ]
    }
]

export const Fan_Section = [
    {
        title: "هواکش",
        link: "/ventilator",
        childs: [
            {
                name: "هواکش صنعتی",
                link: "/lamp-candle"
            },
            {
                name: "هواکش خانگی",
                link: "/lamp-candle"
            },
            {
                name: "پنکه",
                link: "/lamp-candle"
            },
            {
                name: "فن",
                link: "/lamp-candle"
            },
            {
                name: "سانتریفیوژ",
                link: "/lamp-candle"
            },
            {
                name: "بلوتر هود و پکیج",
                link: "/lamp-candle"
            },
            {
                name: "دفیوزر هواکش و فن",
                link: "/lamp-candle"
            },
        ]
    },
]

export const Switch_Section = [
    {
        title: "کلید",
        link: "/light-switch",
        childs: [
            {
                name: "کلید تکی",
                link: "/lamp-candle"
            },
            {
                name: "کلید دوتایی",
                link: "/lamp-candle"
            },
            {
                name: "کلید سه تایی",
                link: "/lamp-candle"
            },
            {
                name: "کلید هوشمند",
                link: "/lamp-candle"
            },
            {
                name: "قاب کلید",
                link: "/lamp-candle"
            },
        ]
    },
    {
        title: "پریز",
        link: "/electric-outlet",
        childs: [
            {
                name: "پریز برق",
                link: "/lamp-candle"
            },
            {
                name: "پریز تلفن",
                link: "/lamp-candle"
            },
        ]
    }
]

export const Protector_Section = [
    {
        title: "لامپ",
        link: "/lamp",
        childs: [
            {
                name: "لامپ شمعی",
                link: "/lamp-candle"
            }
        ]
    },
    {
        title: "ال ای دی",
        link: "/lamp",
        childs: [
            {
                name: "لامپ ال ای دی",
                link: "/lamp-candle"
            }
        ]
    }
]



export const Cable_Section = [
    {
        title: "لامپ",
        link: "/lamp",
        childs: [
            {
                name: "لامپ شمعی",
                link: "/lamp-candle"
            }
        ]
    },
    {
        title: "ال ای دی",
        link: "/lamp",
        childs: [
            {
                name: "لامپ ال ای دی",
                link: "/lamp-candle"
            }
        ]
    }
]

export const Other_Section = [
    {
        title: "لامپ",
        link: "/lamp",
        childs: [
            {
                name: "لامپ شمعی",
                link: "/lamp-candle"
            }
        ]
    },
    {
        title: "ال ای دی",
        link: "/lamp",
        childs: [
            {
                name: "لامپ ال ای دی",
                link: "/lamp-candle"
            }
        ]
    }
]

export const Tasviri_Section = [
    {
        title: "لامپ",
        link: "/lamp",
        childs: [
            {
                name: "لامپ شمعی",
                link: "/lamp-candle"
            }
        ]
    },
    {
        title: "ال ای دی",
        link: "/lamp",
        childs: [
            {
                name: "لامپ ال ای دی",
                link: "/lamp-candle"
            }
        ]
    }
]
